import Form from './Form'
import FormItem from './FormItem'
import validators from './validators'
Form.Item = FormItem
Form.validators = validators
export default Form
